import createIcon from '../../createIcon';

/**
 * @component @name PowerSettingsNew
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgM0gxMVYxM0gxM1YzWk0xNy44MyA1LjE3TDE2LjQxIDYuNTlDMTcuOTkgNy44NiAxOSA5LjgxIDE5IDEyQzE5IDE1Ljg3IDE1Ljg3IDE5IDEyIDE5QzguMTMgMTkgNSAxNS44NyA1IDEyQzUgOS44MSA2LjAxIDcuODYgNy41OCA2LjU4TDYuMTcgNS4xN0M0LjIzIDYuODIgMyA5LjI2IDMgMTJDMyAxNi45NyA3LjAzIDIxIDEyIDIxQzE2Ljk3IDIxIDIxIDE2Ljk3IDIxIDEyQzIxIDkuMjYgMTkuNzcgNi44MiAxNy44MyA1LjE3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PowerSettingsNew = createIcon('PowerSettingsNew', [
  [
    'path',
    {
      d: 'M13 3H11V13H13V3ZM17.83 5.17L16.41 6.59C17.99 7.86 19 9.81 19 12C19 15.87 15.87 19 12 19C8.13 19 5 15.87 5 12C5 9.81 6.01 7.86 7.58 6.58L6.17 5.17C4.23 6.82 3 9.26 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 9.26 19.77 6.82 17.83 5.17Z',
      key: '1hl835',
    },
  ],
]);

export default PowerSettingsNew;
